module.exports = __webpack_public_path__ + "static/media/listen-icon-white.074593dd.svg";